import {createSelector} from '@reduxjs/toolkit';

import {adapter, FinancialTransactionsState, type} from './state';
import {selectedIdSelector as customerSelectedIdSelector} from "../customers/selectors";

const {selectAll} = adapter.getSelectors();

const featureStateSelector = (state: { [type]: FinancialTransactionsState }) => state[type];

export const selectedIdSelector = createSelector(
    featureStateSelector,
    state => state.selectedId
);

export const errorMessageSelector = createSelector(
    featureStateSelector,
    state => state.errorMessage
);

export const isFetchingFinancialTransactionsSelector = createSelector(
    featureStateSelector,
    state => state.isFetching
);

export const financialTransactionsSelector = createSelector(
    featureStateSelector,
    selectAll
);

export const financialTransactionsByActiveCustomerSelector = createSelector(
    [
        financialTransactionsSelector,
        customerSelectedIdSelector,
    ],
    (financialTransactions, customerId) => financialTransactions ? financialTransactions.filter(financialTransaction => financialTransaction.customerId === customerId) : financialTransactions
);

export const selectedFinancialTransactionSelector = createSelector(
    financialTransactionsByActiveCustomerSelector,
    selectedIdSelector,
    (financialTransactions, selectedId) => {
        return financialTransactions.find(transaction => transaction.id === selectedId);
    }
);

export const financialTransactionIdsByActiveCustomerSelector = createSelector(
    financialTransactionsByActiveCustomerSelector,
    (financialTransactions) => {
        // Order ids the same way the account page lists them (runningOrder desc) so
        // document prev/next steps through documents in the order the user sees.
        return [...financialTransactions]
            .sort((a, b) => (a.runningOrder < b.runningOrder ? 1 : -1))
            .map(transaction => transaction.id);
    }
);
